export default "__VITE_IMAGE_ASSET__0eadba79__";